._TourBackdropWrapper_1mhu8_1 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999999;
  background: #ffffff; }
